import styled from 'styled-components';

import ButtonLink from '../UI/ButtonLink/ButtonLink';
import variables from '../../styles/variables';

export const BladeContent = styled.div`
  padding: ${variables.layoutPadding}rem;

  @media screen and (max-width: 500px) {
    padding: ${variables.mobileLayoutPadding}rem;
  }
`;

export const Title = styled.div`
  font-size: 43px;
  font-weight: 600;
  line-height: 48px;
  margin-bottom: 65px;
`;
export const SubTitle = styled.div`
  font-size: 30px;
  font-weight: 500;
  line-height: 30px;
  margin-bottom: 5px;
`;
export const Time = styled.div`
  font-size: 80px;
  font-weight: 600;
  line-height: 89px;
  margin-bottom: 26px;
  color: ${variables.colorRed};
`;
export const Text = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 30px;
  margin-bottom: 30px;
`;
export const OptionButton = styled(ButtonLink)`
  margin-bottom: 40px;

  @media screen and (max-width: 760px) {
    margin-bottom: 20px;
  }
`;
